import { useState } from "react";
import { Copy, Check } from "lucide-react";
import "./payment-status.css";

export default function PaymentStatusShell({
  icon,
  tone = "info",
  badge,
  title,
  subtitle,
  transactionID,
  actions,
  note,
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(transactionID).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="ps-page">
      <div className="ps-card">

        <div className={`ps-icon-ring ${tone}`}>
          {icon}
        </div>

        <p className="ps-badge">{badge}</p>
        <h1 className="ps-title">{title}</h1>
        <p className="ps-subtitle">{subtitle}</p>

        {transactionID && (
          <div className="ps-txn">
            <div style={{ minWidth: 0 }}>
              <span className="ps-txn-label">Transaction ID</span>
              <span className="ps-txn-value">{transactionID}</span>
            </div>
            <button
              className={`ps-txn-copy ${copied ? "copied" : ""}`}
              onClick={handleCopy}
              title="Copy transaction ID"
            >
              {copied ? <Check size={15} /> : <Copy size={15} />}
            </button>
          </div>
        )}

        {actions && (
          <>
            <hr className="ps-divider" />
            <div className="ps-actions">{actions}</div>
          </>
        )}

        {note && <p className="ps-note">{note}</p>}
      </div>
    </div>
  );
}
